import { Loan, LoanOffer, LoanRepayment, LoanStatusId } from '../../interfaces/loan';
import { AddLoanOfferAction, FetchLoanOffersAction, FetchLoanRepaymentsAction, GetLoanAction, UpdateLoanDisbursementCheckerAction, UpdateLoanOffersAction, UpdateLoanRepaymentsAction, UpdateLoanStatusAction } from '../actions/loan.actions';
import { ActionType } from '../action_types';

export const getLoan = (loan: Loan | null): GetLoanAction => {
  return {
    type: ActionType.GET_LOAN,
    payload: { loan },
  };
};

export const updateLoanStatus = (status: LoanStatusId): UpdateLoanStatusAction => {
  return {
    type: ActionType.UPDATE_LOAN_STATUS,
    payload: { status },
  };
};

export const UpdateLoanDisbursementChecker = (status: boolean): UpdateLoanDisbursementCheckerAction => {
  return {
    type: ActionType.UPDATE_LOAN_DISBURSEMENT_CHECKER,
    payload: { status },
  };
};

export const fetchLoanOffers = (loanOffers: LoanOffer[]): FetchLoanOffersAction => {
  return {
    type: ActionType.LOAN_OFFERS,
    payload: { loanOffers },
  };
};

export const addLoanOffer = (loanOffer: LoanOffer): AddLoanOfferAction => {
  return {
    type: ActionType.ADD_LOAN_OFFER,
    payload: { loanOffer },
  };
};

export const updateLoanOffer = (loanOffer: LoanOffer): UpdateLoanOffersAction => {
  return {
    type: ActionType.UPDATE_LOAN_OFFERS,
    payload: { loanOffer },
  };
};

export const fetchLoanRepayments = (loanRepayments: LoanRepayment[]): FetchLoanRepaymentsAction => {
  return {
    type: ActionType.FETCH_LOAN_REPAYMENTS,
    payload: {loanRepayment: loanRepayments}
  }
}

// Incomplete -- most likely incorrect
export const updateLoanRepayments = (loanRepayments: LoanRepayment[], repayments: number): UpdateLoanRepaymentsAction => {
  for (let i = 0; i < repayments; i++) {
    loanRepayments[i].paid = true
    loanRepayments[i].paid_date = Date.now().toLocaleString()
  }
  return {
    type: ActionType.UPDATE_LOAN_REPAYMENTS,
    payload: {loanRepayment: loanRepayments}
  }
}
